import { Project } from "./project";

export class ProjectProfitData {
  project: Project | null = null;
  plannedProfit: number = 0;
  actualProfit: number = 0;
}
